import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../../box';
import { IconLocationOn } from '../../icon';
import { Typography } from '../../typography';
export const facilityValueTypography = {
    maxWidth: 250,
    variant: 'body2',
    fontWeight: 500
};
export const FacilityValue = React.forwardRef((props, ref) => {
    return (_jsxs(FlexBox, { ref: ref, gap: 0.5, vAlign: "center", height: "100%", sx: { pointerEvents: 'none', ...props.sx }, children: [_jsx(IconLocationOn, { color: "components.facility.contrast.icon", fontSize: "small", ref: props.onIconRef }), !props.reduced && (_jsx(Typography, { ...facilityValueTypography, noWrap: true, color: props.topNav
                    ? 'components.facility.contrast.text-top-navigation'
                    : 'components.facility.contrast.text', textTransform: "sentence", children: props.children }))] }));
});
